import {
  PATH_DEBUG_SEARCH,
  PATH_DEBUG_RESULTS,
  PATH_DEBUG_SUMMARY,
} from '../../../../route/constants';

export const DEBUG_STEPS = [
  { label: 'Search', path: PATH_DEBUG_SEARCH },
  { label: 'Results', path: PATH_DEBUG_RESULTS },
  { label: 'Summary', path: PATH_DEBUG_SUMMARY },
];
